import { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';
import { AppService } from 'app/services/app.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import FilterFields from './filter.fields';
import { DomSanitizer } from '@angular/platform-browser';
import { DomainFilterService } from 'app/services/domain-filter.service';
var ɵ0 = { useUtc: true }, ɵ1 = MAT_MOMENT_DATE_FORMATS;
var NavbarVerticalStyle2Component = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {Router} _router
     */
    function NavbarVerticalStyle2Component(_appService, _filterDomain, _fuseConfigService, _fuseNavigationService, _fuseSidebarService, _router, formBuilder, sanitizer) {
        this._appService = _appService;
        this._filterDomain = _filterDomain;
        this._fuseConfigService = _fuseConfigService;
        this._fuseNavigationService = _fuseNavigationService;
        this._fuseSidebarService = _fuseSidebarService;
        this._router = _router;
        this.formBuilder = formBuilder;
        this.sanitizer = sanitizer;
        this.fileterFields = FilterFields;
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.filterFormGroup = this.formBuilder.group({
            domain_id: null,
        });
    }
    Object.defineProperty(NavbarVerticalStyle2Component.prototype, "directive", {
        // -----------------------------------------------------------------------------------------------------
        // @ Accessors
        // -----------------------------------------------------------------------------------------------------
        // Directive
        set: function (theDirective) {
            var _this = this;
            if (!theDirective) {
                return;
            }
            this._fusePerfectScrollbar = theDirective;
            // Update the scrollbar on collapsable item toggle
            this._fuseNavigationService.onItemCollapseToggled
                .pipe(delay(500), takeUntil(this._unsubscribeAll))
                .subscribe(function () {
                _this._fusePerfectScrollbar.update();
            });
            // Scroll to the active item position
            this._router.events
                .pipe(filter(function (event) { return event instanceof NavigationEnd; }), take(1))
                .subscribe(function () {
                setTimeout(function () {
                    var activeNavItem = document.querySelector('navbar .nav-link.active');
                    if (activeNavItem) {
                        var activeItemOffsetTop = activeNavItem.offsetTop, activeItemOffsetParentTop = !activeNavItem.offsetParent ? 0 : activeNavItem.offsetParent.offsetTop, scrollDistance = activeItemOffsetTop - activeItemOffsetParentTop - (48 * 3);
                        _this._fusePerfectScrollbar.scrollToTop(scrollDistance);
                    }
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    NavbarVerticalStyle2Component.prototype.ngOnInit = function () {
        var _this = this;
        this._router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }), takeUntil(this._unsubscribeAll))
            .subscribe(function () {
            if (_this._fuseSidebarService.getSidebar('navbar')) {
                _this._fuseSidebarService.getSidebar('navbar').close();
            }
        });
        // Get current navigation
        this._fuseNavigationService.onNavigationChanged
            .pipe(filter(function (value) { return value !== null; }), takeUntil(this._unsubscribeAll))
            .subscribe(function () {
            _this.navigation = _this._fuseNavigationService.getCurrentNavigation();
        });
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (config) {
            _this.fuseConfig = config;
        });
        this._appService.appEvent
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (res) {
            if (res.name == 'open-menu') {
                _this.unfoldSidebar();
            }
            else {
                _this.foldSidebar();
            }
        });
        this._filterDomain.domainData
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (domainData) {
            if (!domainData)
                return;
            _this.domainLogoId = domainData.logo;
        });
    };
    /**
     * On destroy
     */
    NavbarVerticalStyle2Component.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    NavbarVerticalStyle2Component.prototype.ngAfterViewInit = function () { };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Toggle sidebar opened status
     */
    NavbarVerticalStyle2Component.prototype.toggleSidebarOpened = function () {
        this._fuseSidebarService.getSidebar('navbar').toggleOpen();
    };
    /**
     * Toggle sidebar folded status
     */
    NavbarVerticalStyle2Component.prototype.toggleSidebarFolded = function () {
        this._fuseSidebarService.getSidebar('navbar').toggleFold();
    };
    NavbarVerticalStyle2Component.prototype.unfoldSidebar = function () {
        this._fuseSidebarService.getSidebar('navbar').unfold();
    };
    NavbarVerticalStyle2Component.prototype.foldSidebar = function () {
        this._fuseSidebarService.getSidebar('navbar').fold();
    };
    NavbarVerticalStyle2Component.prototype.unfoldTemporarily = function () {
        this._fuseSidebarService.getSidebar('navbar').unfoldTemporarily();
    };
    NavbarVerticalStyle2Component.prototype.isUnfolded = function () {
        return this._fuseSidebarService.getSidebar('navbar').unfolded;
    };
    return NavbarVerticalStyle2Component;
}());
export { NavbarVerticalStyle2Component };
export { ɵ0, ɵ1 };
